import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useInstallationGuide } from '../../../hooks/useInstallationGuide';
import { GuidanceSection } from '../GuidanceSection';
import { WizardNavigation } from '../WizardNavigation';

/** Path to the router + Core connection diagram */
const ROUTER_CORE_DIAGRAM_PATH = '/assets/images/installation-guide/router-core-connect.png';

/**
 * ConnectOverviewStep - Slide 2.5: Connect Overview
 *
 * Shows an overview of the router + Core connection with:
 * - Connection diagram showing router and Core with ethernet cable
 * - Two chatbot help buttons for router identification and port issues
 */
export const ConnectOverviewStep: React.FC = () => {
  const { goToStep, setMainStepId } = useInstallationGuide();

  useEffect(() => {
    setMainStepId('step_connectCoreRouter');
  }, [setMainStepId]);

  const handleContinue = () => {
    goToStep('connect-router');
  };

  const guidanceButtons = [
    { label: __('Help me identify my router'), flowId: 'identify-router' },
    { label: __('There are no open ports'), flowId: 'no-open-ports' },
  ];

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h3" component="h1" sx={{ mb: 1, textAlign: 'center' }}>
        {__("Now, let's connect your Core and router.")}
      </Typography>

      <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
        {__(
          'Now that your Core is placed, the next two steps will walk through connecting the Core to your router.'
        )}
      </Typography>

      {/* Router + Core connection diagram */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          my: 2,
        }}
      >
        <Box
          component="img"
          src={ROUTER_CORE_DIAGRAM_PATH}
          alt={__('Router and Core connection diagram')}
          sx={{
            maxWidth: '100%',
            maxHeight: 300,
            objectFit: 'contain',
          }}
        />
      </Box>

      {/* Guidance section with chatbot buttons */}
      <GuidanceSection
        buttons={guidanceButtons}
      />

      <WizardNavigation
        primaryLabel={__('Continue')}
        onPrimary={handleContinue}
      />
    </Box>
  );
};
